import { useEffect, useState } from "react";
import { Video } from "lucide-react";
import { http } from "@/lib/api";
import { JoinButton, ClassTime, useMinuteTick } from "@/components/school/SchoolClasses";
import { PROVIDER_LABEL } from "@/components/school/SchoolConnect";

const isLive = (c) => { const n = Date.now(); return n >= new Date(c.start_at) - 10 * 60000 && n <= new Date(c.end_at); };
const isOver = (c) => Date.now() > new Date(c.end_at);

export const KidClasses = ({ kid }) => {
  const [d, setD] = useState(null);
  useMinuteTick();
  useEffect(() => { http.get(`/students/${kid.id}/school-classes`).then((r) => setD(r.data)).catch(() => {}); }, [kid.id]);
  if (!d || (!d.classes.length && !d.week_count)) return null;
  return (
    <section className="mt-5 rounded-2xl bg-[#FFF8F1] border border-[#F6C9A3] p-4" data-testid={`parent-classes-${kid.id}`}>
      <div className="flex items-center gap-2">
        <p className="text-xs uppercase tracking-widest text-stone-500 flex-1 inline-flex items-center gap-1.5"><Video className="w-4 h-4 text-[#F28C38]" /> School live classes today</p>
        <span className="text-xs text-stone-600" data-testid={`parent-classes-week-${kid.id}`}>{d.week_count} this week</span>
      </div>
      {!d.classes.length ? <p className="text-sm text-stone-500 mt-2">No live classes today.</p> : (
        <ul className="mt-2 space-y-2">{d.classes.map((c) => (
          <li key={c.uid} className={`flex flex-wrap items-center gap-3 rounded-xl bg-white px-3 py-2 text-sm ${isOver(c) ? "opacity-60" : ""}`} data-testid={`parent-class-${kid.id}-${c.uid}`}>
            <span className="w-44 whitespace-nowrap font-medium text-[#2C4A3E]"><ClassTime c={c} /></span>
            <span className="flex-1 min-w-[160px] text-[#1F3D33]">{c.title} <span className="text-xs text-stone-500">· {PROVIDER_LABEL[c.provider || "other"]} · {c.course}</span></span>
            {isLive(c) && <span className="text-xs font-semibold text-[#C0571B]">LIVE NOW</span>}
            {isOver(c) && <span className="text-xs text-stone-500">Ended</span>}
            <JoinButton c={c} small where={`parent-${kid.id}`} />
          </li>))}</ul>
      )}
    </section>
  );
};
